module.exports = __webpack_public_path__ + "static/media/icon_info.85c485ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_info.svg
// module id = 173
// module chunks = 0